import type { RxJsonSchema } from 'rxdb';
import type { WorkPackages } from './workPackages.types';

export const workPackagesSchema: RxJsonSchema<WorkPackages> = {
  type: 'object',
  version: 1,
  description: 'describes work package',
  primaryKey: 'workPackageId',
  properties: {
    workPackageId: { type: 'string', maxLength: 36 },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    workPackageName: { type: ['string', 'null'] },
    workPackageStatus: { type: ['string', 'null'] },
    workPackageStatusId: { type: ['number', 'null'] },
    noOfInspections: { type: ['number', 'null'] },
    inspectorId: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    isLeadInspector: { type: ['boolean', 'null'] },
    isAdhoc: { type: ['boolean', 'null'] },
  },
};
